import React from "react"
import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"
import Icon from "@irati/ui/src/Icon"
import {twoPxShadow} from "@irati/ui/src/global/elevation"

const Circle = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: ${greys.white};
  border: 1px solid ${greys.black};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  ${twoPxShadow}
`

const CurrentPositionMarker = () => {
  return (
    <Circle>
      <Icon color={greys.black} icon="geoArrow" size={12} />
    </Circle>
  )
}

export default CurrentPositionMarker
